function key2string(key: string) {
  return `'${key}'`;
}

export type ApplicationExceptionSeverity =
  "danger" | "warning" | "info" | "success";

export class ApplicationException extends Error {
  severity: ApplicationExceptionSeverity;

  constructor(msg: string, severity: ApplicationExceptionSeverity = "danger") {
    super(msg);
    this.severity = severity;
  }
}

export class NetworkException extends ApplicationException {
  code: number;

  constructor(
    msg: string,
    code: number,
    severity: ApplicationExceptionSeverity = "danger"
  ) {
    if (code == 429) {
      severity = "warning";
      msg = "Too Many Requests. Please try again later." + msg;
    }

    super(msg, severity);
    this.code = code;
  }
}

export class ConfigurationException extends ApplicationException {}

class DataException extends ApplicationException {
  #key = "";

  constructor(key: string, msg: string) {
    super(msg);
    this.#key = key;
    this.message = msg;
  }

  getKey() {
    return this.#key;
  }
}

export class DataMissingException extends DataException {
  constructor(key: string) {
    super(key, `${key2string(key)} is not defined`);
  }
}

export class DataOutOfBoundException extends DataException {
  constructor(key: string, value: string | number, limits?: [number, number]) {
    super(
      key,
      `${key2string(key)} is out-of-bounds: ${value}${
        limits ? ` [${limits[0]} -> ${limits[1]}]` : ""
      }`
    );
  }
}

export class DataInvalidException extends DataException {
  constructor(key: string, value?: string | number | undefined | null) {
    super(
      key,
      `${key2string(key)} is invalid` +
        (value !== undefined ? ` (${JSON.stringify(value)})` : "")
    );
  }
}
